import React, { memo, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { CustomerBusinessInformationForm } from 'src/components/customer/customer-business-information-form/CustomerBusinessInformationForm'
import { getCustomerProfile } from 'src/selectors/customer'
import { useNavigate } from 'react-router-dom'
import { getPartner } from 'src/selectors/user'
import { FullScreenLoader } from 'src/components/shared/FullScreenLoader'
import { Button } from 'src/components/shared/Button'
import tw from 'twin.macro'
import { ChevronLeftMinor } from '@shopify/polaris-icons'
import { getMCBusinessType } from 'src/utils/mcUtils'
import { ROUTES } from 'src/constants/routes'

const CustomerResubmitBusinessInformationPageComponent = () => {
  const navigate = useNavigate()

  const customerProfile = useSelector(getCustomerProfile)
  const customer = useSelector(getPartner)

  const initialValues = useMemo(() => {
    const initialBusinessType = customerProfile?.partnerInformation?.businessType || ''

    const { businessType, otherBusinessType } = getMCBusinessType(initialBusinessType)

    return {
      companyName: customer?.displayName || '',
      businessType,
      otherBusinessType: otherBusinessType || '',
      dotNumber: customerProfile?.partnerInformation?.dotNumber || '',
      addressStreet1: customerProfile?.partnerInformation?.addressStreet1 || '',
      addressStreet2: customerProfile?.partnerInformation?.addressStreet2 || '',
      addressCity: customerProfile?.partnerInformation?.addressCity || '',
      addressState: customerProfile?.partnerInformation?.addressState || '',
      addressPostalCode: customerProfile?.partnerInformation?.addressPostalCode || '',
      taxIdType: '',
      ein: '',
      itin: '',
    }
  }, [customer?.displayName, customerProfile?.partnerInformation])

  const handleBack = useCallback(() => {
    navigate(ROUTES.BASE_URL)
  }, [navigate])

  if (!customerProfile) {
    return <FullScreenLoader />
  }

  return (
    <>
      <CustomerBusinessInformationForm initialValues={initialValues} onSubmit={handleBack} />
      <div css={tw`absolute left-4 top-20`}>
        <Button
          onClick={handleBack}
          leftIcon={<ChevronLeftMinor width={20} height={20} fill="white" />}
          size="small"
          color="black"
        >
          Back
        </Button>
      </div>
    </>
  )
}

export const CustomerResubmitBusinessInformationPage = memo(
  CustomerResubmitBusinessInformationPageComponent,
)
